import React from "react";
import Signup from "../components/Signup";

const SignupScreen = () => {
  return <Signup />;
};

export default SignupScreen;
